import Vue from "vue";
import lang from '../../lang'

const defaultLocale = "de";

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

export default new VueI18n({
    fallbackLocale: defaultLocale,
    locale: defaultLocale,
    messages: lang
});
